/**
 * @file
 * Provides javascript behaviors for floating labels.
 *
 * @see httpdocs/themes/aw/src/scss/components/form-elements/_labels_floating.scss
 */

(function ($, Drupal) {

  Drupal.behaviors.label = {
    attach: function attach(context) {
      let $inputs = $('.js-floating-label-trigger');
      let $selects = $('.js-select-replace');

      $inputs.each(function () {
        setFloatingLabel($(this));
      });

      $inputs.on('focus input change', function () {
        setFloatingLabel($(this), true);
      });

      $inputs.on('blur', function () {
        setFloatingLabel($(this), false);
      });

      $selects.on('select2:select', function () {
        setFloatingLabel($(this), true);
      });

      function setFloatingLabel($input, force) {
        let $label = $input.parent('.js-form-item:not(fieldset)').find('.label:not(.sr-only)'),
          labelPlacedClass = 'js-floating-placed',
          labelFloatedClass = 'js-is-floating';

        $label.addClass(labelPlacedClass);

        if (force || $input.val() != false || $input.is(':focus')) {
          $label.addClass(labelFloatedClass);
        } else {
          $label.removeClass(labelFloatedClass);
        }
      }
    }
  };
})(jQuery, Drupal);
